<ng-container *transloco="let _t">

<p class="right">
	<button mat-raised-button color="secondary"
		(click)="reset()">
		<mat-icon class="md-12">refresh</mat-icon>
		{{ _t('Recommencer')}}
	</button>
	&nbsp;
	<button mat-raised-button color="basic"
		(click)="save()">
		<mat-icon class="md-12">save</mat-icon>
		{{ _t('Enregistrer') }}
	</button>
</p>
<h2>{{ _t('building-datasheet-h2-0') }}</h2>
<p><mat-icon color="warn">warning</mat-icon>
<cmat-seemore [content]="_t('building-datasheet-text')" [max]="102"></cmat-seemore></p>
<app-tinymce [(ngModel)]="content" value="test" *ngIf="prepared"></app-tinymce>


</ng-container>